import React from "react";
import { useNewsStore } from "../../../stores/use-news-store";
import { BlogEditorContainer } from "./styled";
import DynamicNews from "../data/DynamicNews";
import ManualNews from "../data/ManualNews";
import EditingTabs from "../tabs/EditingTabs";

function NewsEditor() {
  const { data, selectedTab } = useNewsStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
  }));

  const { enrichment } = data?.config?.tabs?.[selectedTab] || {};

  return (
    <BlogEditorContainer>
      <EditingTabs />
      {enrichment === "dynamic" && <DynamicNews />}
      {enrichment === "manually" && <ManualNews isEdit />}
    </BlogEditorContainer>
  );
}

export default NewsEditor;
